import { FC, PropsWithChildren } from 'external/react'
import AssetImage from './AssetImage'

const FormLayout: FC<PropsWithChildren> = props => {
	const {children} = props

	return (
		<>
			<AssetImage className='imageContentCloud' src='login/cloud.png' alt='Illustration Cloud' />
			<div className='contentLeft'>
				<AssetImage className='contentLeftImage' src='illustrations/information.png' alt='Illustration Information' />
			</div>
			<div className='contentRight'>
				<AssetImage className='contentRightLogo' src='login/dreyfous.png' alt='Dreyfous' />
				<div className='contentForm'>
					{children}
				</div>
			</div>
		</>
	)
}

export {FormLayout as default}